"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "corinaldo": {
    "67928b0d": [{
      "hkey": "cb9b5f6d",
      "slug": "corinaldo",
      "name": "Corinaldo",
      "primary": true,
      "skipSearch": false
    }],
    "cesano": [{
      "hkey": "cb9b5f6d",
      "slug": "corinaldo",
      "name": "Corinaldo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8f9b233a": [{
      "hkey": "cb9b5f6d",
      "slug": "corinaldo",
      "name": "Corinaldo",
      "primary": true,
      "skipSearch": false
    }],
    "nevola": [{
      "hkey": "cb9b5f6d",
      "slug": "corinaldo",
      "name": "Corinaldo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "05d3e974": [{
      "hkey": "cb9b5f6d",
      "slug": "corinaldo",
      "name": "Corinaldo",
      "primary": true,
      "skipSearch": false
    }],
    "san-bartolo": [{
      "hkey": "cb9b5f6d",
      "slug": "corinaldo",
      "name": "Corinaldo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fc89e0b2": [{
      "hkey": "cb9b5f6d",
      "slug": "corinaldo",
      "name": "Corinaldo",
      "primary": true,
      "skipSearch": false
    }],
    "san-domenico": [{
      "hkey": "cb9b5f6d",
      "slug": "corinaldo",
      "name": "Corinaldo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d6be03e3": [{
      "hkey": "cb9b5f6d",
      "slug": "corinaldo",
      "name": "Corinaldo",
      "primary": true,
      "skipSearch": false
    }],
    "san-vincenzo": [{
      "hkey": "cb9b5f6d",
      "slug": "corinaldo",
      "name": "Corinaldo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "57e3cbd0": [{
      "hkey": "cb9b5f6d",
      "slug": "corinaldo",
      "name": "Corinaldo",
      "primary": true,
      "skipSearch": false
    }],
    "santa-maria": [{
      "hkey": "cb9b5f6d",
      "slug": "corinaldo",
      "name": "Corinaldo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;